import BaseEntity from "@/core/misc/BaseEntity";

class EdiOperator extends BaseEntity {
    public name: string;

    static fromServer(data: any, result = new EdiOperator()): EdiOperator {
        super.fromServer(data, result);
        return result;
    }
}

export default EdiOperator;